import { useContext } from "react";
import { MorphemeTilePresentationContext } from "#morpheme-tile-presentation-context";

export function useMorphemeTilePresentation() {
  const presentation = useContext(MorphemeTilePresentationContext);
  if (presentation === null) {
    throw new Error("Morpheme tile presentation requires MorphemeTilePresentationProvider");
  }
  return presentation;
}
